import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
const { FiShield, FiSmartphone, FiRefreshCw, FiCopy, FiCheck, FiKey } = FiIcons;
import SafeIcon from '../common/SafeIcon';
import api from '../lib/api';
import toast from 'react-hot-toast';

export default function MFAEnrollment() {
  const [step, setStep] = useState(1);
  const [recoveryCodes, setRecoveryCodes] = useState([]);
  const [isRegenerating, setIsRegenerating] = useState(false);

  const regenerateCodes = async () => {
    setIsRegenerating(true);
    try {
      const { data } = await api.post('/api/v1/users/mfa/recovery/regenerate');
      setRecoveryCodes(data.codes);
      toast.success('New recovery codes generated');
    } catch (err) {
      toast.error('Regeneration failed');
    } finally {
      setIsRegenerating(false);
    }
  };

  return (
    <div className="bg-white rounded-[2rem] p-8 shadow-2xl shadow-slate-200 border border-slate-100 max-w-md mx-auto">
      <div className="text-center mb-8">
        <div className="w-16 h-16 bg-brand-500 text-white rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-xl shadow-brand-100">
          <SafeIcon icon={FiKey} className="text-2xl" />
        </div>
        <h2 className="text-2xl font-black text-slate-900 tracking-tight">Security Access</h2>
        <p className="text-slate-500 text-sm mt-1">Manage your recovery and MFA status</p>
      </div>

      <div className="space-y-6">
        <div className="bg-amber-50 border border-amber-100 p-4 rounded-2xl">
          <div className="flex gap-3">
            <SafeIcon icon={FiSmartphone} className="text-amber-600 mt-1" />
            <div>
              <p className="text-sm font-bold text-amber-900">Recovery Codes</p>
              <p className="text-xs text-amber-700 leading-relaxed">If you lose your authenticator app, these codes are the ONLY way to regain access. Keep them safe.</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2">
          {recoveryCodes.map((code, idx) => (
            <div key={idx} className="bg-slate-50 p-2 rounded-lg border border-slate-100 font-mono text-[10px] text-center text-slate-600 font-bold">
              {code}
            </div>
          ))}
        </div>

        <button 
          onClick={regenerateCodes}
          disabled={isRegenerating}
          className="w-full py-4 bg-slate-900 text-white rounded-2xl font-black uppercase tracking-widest text-[10px] flex items-center justify-center gap-2 hover:bg-brand-600 transition-all"
        >
          {isRegenerating ? <SafeIcon icon={FiRefreshCw} className="animate-spin" /> : <SafeIcon icon={FiRefreshCw} />}
          Regenerate Recovery Codes
        </button>

        <div className="text-center">
            <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest">
                Last updated: {new Date().toLocaleDateString()}
            </p>
        </div>
      </div>
    </div>
  );
}